import * as React from "react";

const SvgPlaylistAddCheck = ({ color, size }) => (
  <svg
    viewBox="0 0 23 23"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.9 5.7h11.4v1.9H1.9V5.7zm0 3.8h11.4v1.9H1.9V9.5zm0 3.8h7.6v1.9H1.9v-1.9zm13.31 2.85-2.86-2.85-1.425 1.425L15.209 19l6.64-6.65-1.424-1.425-5.216 5.225z"
      fill={color}
    />
  </svg>
);

export default SvgPlaylistAddCheck;
